function ihInitBasics(scope=document){
  scope.querySelectorAll?.('[data-ih-country]').forEach(s=>{
    if(s.dataset.ihBound==='true') return;
    s.dataset.ihBound='true';
    s.addEventListener('change',()=>s.form?.submit());
  });

  scope.querySelectorAll?.('[data-ih-close-menu]').forEach(b=>{
    if(b.dataset.ihBound==='true') return;
    b.dataset.ihBound='true';
    b.addEventListener('click',()=>{
      const d=b.closest('details');
      if(d) d.removeAttribute('open');
    });
  });

  scope.querySelectorAll?.('.ih-scroll-shell').forEach(shell=>{
    if(shell.dataset.ihBound==='true') return;
    shell.dataset.ihBound='true';
    const track=shell.querySelector('[data-ih-scroll-track]');
    if(!track) return;
    const prev=shell.querySelector('[data-ih-scroll-prev]');
    const next=shell.querySelector('[data-ih-scroll-next]');
    const go=d=>track.scrollBy({left:d*Math.max(track.clientWidth*.82,280),behavior:'smooth'});
    prev?.addEventListener('click',()=>go(-1));
    next?.addEventListener('click',()=>go(1));
  });
}

function ihInitHero(hero){
  if(!hero || hero.dataset.ihHeroBound==='true') return;
  hero.dataset.ihHeroBound='true';

  const slides=[...hero.querySelectorAll('[data-ih-slide]')];
  const dots=[...hero.querySelectorAll('[data-ih-hero-dot]')];
  if(!slides.length) return;

  let index=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
  let timer=null;
  let touchStartX=null;
  const syncImageRatio=()=>{
    const mobile=window.matchMedia('(max-width:749px)').matches;
    if(!(mobile?hero.dataset.mobileAuto==='true':hero.dataset.desktopAuto==='true'))return;
    const current=slides[index];
    const key=mobile?'--ih-hero-mobile-ratio':'--ih-hero-desktop-ratio';
    const ratio=Number.parseFloat(current?.style.getPropertyValue(key));
    if(Number.isFinite(ratio)&&ratio>0)hero.style.setProperty('--ih-hero-active-ratio',String(ratio));
  };
  window.addEventListener('resize',syncImageRatio,{passive:true});

  const autoplay=hero.dataset.autoplay==='true';
  const pauseOnHover=hero.dataset.pauseHover==='true';
  const speed=Math.max(1000,Number(hero.dataset.speed)||6000);

  const show=n=>{
    index=(n+slides.length)%slides.length;
    slides.forEach((slide,i)=>{
      const active=i===index;
      slide.classList.toggle('is-active',active);
      slide.setAttribute('aria-hidden',active?'false':'true');
    });
    syncImageRatio();
    dots.forEach((dot,i)=>{
      const active=i===index;
      dot.classList.toggle('is-active',active);
      dot.setAttribute('aria-current',active?'true':'false');
    });
  };

  const stop=()=>{
    if(timer){
      clearInterval(timer);
      timer=null;
    }
  };

  const start=()=>{
    stop();
    if(autoplay && slides.length>1 && !document.hidden){
      timer=setInterval(()=>show(index+1),speed);
    }
  };

  const interact=fn=>{
    fn();
    start();
  };

  hero.querySelector('[data-ih-hero-prev]')?.addEventListener('click',e=>{
    e.preventDefault();
    e.stopPropagation();
    interact(()=>show(index-1));
  });

  hero.querySelector('[data-ih-hero-next]')?.addEventListener('click',e=>{
    e.preventDefault();
    e.stopPropagation();
    interact(()=>show(index+1));
  });

  dots.forEach(dot=>dot.addEventListener('click',e=>{
    e.preventDefault();
    e.stopPropagation();
    interact(()=>show(Number(dot.dataset.ihHeroDot)||0));
  }));

  if(pauseOnHover){
    hero.addEventListener('mouseenter',stop);
    hero.addEventListener('mouseleave',start);
  }

  hero.addEventListener('touchstart',e=>{
    touchStartX=e.changedTouches?.[0]?.clientX ?? null;
  },{passive:true});

  hero.addEventListener('touchend',e=>{
    if(touchStartX===null) return;
    const endX=e.changedTouches?.[0]?.clientX ?? touchStartX;
    const delta=endX-touchStartX;
    touchStartX=null;
    if(Math.abs(delta)<50) return;
    interact(()=>show(delta<0?index+1:index-1));
  },{passive:true});

  document.addEventListener('visibilitychange',()=>{
    if(document.hidden) stop();
    else start();
  });

  show(index);
  start();
}

function ihInitAll(scope=document){
  ihInitBasics(scope);
  scope.querySelectorAll?.('[data-ih-hero]').forEach(ihInitHero);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>ihInitAll(document),{once:true});
}else{
  ihInitAll(document);
}

document.addEventListener('shopify:section:load',e=>ihInitAll(e.target));
document.addEventListener('shopify:block:select',e=>{
  const slide=e.target?.closest?.('[data-ih-slide]');
  const hero=slide?.closest?.('[data-ih-hero]');
  if(!slide||!hero) return;
  const slides=[...hero.querySelectorAll('[data-ih-slide]')];
  const dots=[...hero.querySelectorAll('[data-ih-hero-dot]')];
  const index=slides.indexOf(slide);
  slides.forEach((s,i)=>{
    const active=i===index;
    s.classList.toggle('is-active',active);
    s.setAttribute('aria-hidden',active?'false':'true');
  });
  dots.forEach((d,i)=>{
    const active=i===index;
    d.classList.toggle('is-active',active);
    d.setAttribute('aria-current',active?'true':'false');
  });
  const mobile=window.matchMedia('(max-width:749px)').matches;
  const ratio=Number.parseFloat(slide.style.getPropertyValue(mobile?'--ih-hero-mobile-ratio':'--ih-hero-desktop-ratio'));
  if(Number.isFinite(ratio)&&ratio>0)hero.style.setProperty('--ih-hero-active-ratio',String(ratio));
});


/* IH MLV — matching left-side currency tabs for mobile and desktop */
(()=>{
  let widget=null, observer=null, raf=0, attempts=0;
  const openClass='ih-mobile-currency-open';
  const desktopOpenClass='ih-desktop-currency-open';
  const CODES=/\b(INR|USD|EUR|GBP|AED|AUD|CAD|SGD|JPY|CNY|HKD|NZD|CHF|ZAR|SAR|QAR|KWD|BHD|OMR)\b/i;
  const MOBILE_MAX=749;
  function validCandidate(el){
    if(!el||el.nodeType!==1||el.closest('.ih-aza2-header')||el.closest('.ih-footer-v2'))return false;
    const s=getComputedStyle(el),r=el.getBoundingClientRect();
    return s.display!=='none' && s.visibility!=='hidden' && r.width>=30 && r.width<=260 && r.height>=20 && r.height<=110;
  }
  function fixedAncestor(el){
    let n=el;
    while(n&&n!==document.body){
      if(getComputedStyle(n).position==='fixed')return n;
      n=n.parentElement;
    }
    return null;
  }
  function currencySelect(sel){
    return sel?.tagName==='SELECT' && [...sel.options].filter(o=>CODES.test((o.value||'')+' '+(o.textContent||''))).length>=2;
  }
  function findWidget(){
    if(widget&&document.contains(widget))return widget;
    const selectors=['[data-ih-mlv-widget="true"]','.pick_currency.mldesk','.pick_currency','.currency-picker','.js-currencies-form','[class*="mlveda" i][class*="curr" i]','[id*="mlveda" i][id*="curr" i]'];
    for(const selector of selectors){
      for(const el of document.querySelectorAll(selector)){
        const root=fixedAncestor(el)||el;
        if(validCandidate(root))return root;
      }
    }
    for(const sel of document.querySelectorAll('select')){
      if(!currencySelect(sel))continue;
      const root=fixedAncestor(sel)||sel.parentElement;
      if(validCandidate(root))return root;
    }
    return null;
  }
  function signature(){
    if(!widget)return '';
    const select=widget.querySelector('select');
    return select?'select:'+(select.value||''):(widget.textContent||'').replace(/\s+/g,' ').trim();
  }
  function mobileTab(){
    let tab=document.querySelector('.ih-mobile-currency-tab');
    if(tab||window.innerWidth>MOBILE_MAX)return tab;
    tab=document.createElement('button');
    tab.type='button';
    tab.className='ih-mobile-currency-tab';
    tab.setAttribute('aria-label','Open currency selector');
    tab.setAttribute('aria-expanded','false');
    tab.innerHTML='<span class="ih-mobile-currency-tab__symbol" aria-hidden="true">₹</span><span class="ih-mobile-currency-tab__text" aria-hidden="true">CURRENCY</span>';
    tab.addEventListener('click',()=>{
      const next=!document.documentElement.classList.contains(openClass);
      document.documentElement.classList.toggle(openClass,next);
      tab.setAttribute('aria-expanded',String(next));
      tab.setAttribute('aria-label',next?'Close currency selector':'Open currency selector');
      schedule();
      if(next)widget?.querySelector('select,button')?.focus({preventScroll:true});
    });
    document.body.appendChild(tab);
    return tab;
  }
  function desktopTab(){
    let tab=document.querySelector('.ih-desktop-currency-tab');
    if(tab||window.innerWidth<=MOBILE_MAX)return tab;
    tab=document.createElement('button');
    tab.type='button';
    tab.className='ih-desktop-currency-tab';
    tab.setAttribute('aria-label','Open currency selector');
    tab.setAttribute('aria-expanded','false');
    tab.innerHTML='<span class="ih-desktop-currency-tab__symbol" aria-hidden="true">₹</span><span class="ih-desktop-currency-tab__text" aria-hidden="true">CURRENCY</span>';
    tab.addEventListener('click',()=>{
      const next=!document.documentElement.classList.contains(desktopOpenClass);
      document.documentElement.classList.toggle(desktopOpenClass,next);
      tab.setAttribute('aria-expanded',String(next));
      tab.setAttribute('aria-label',next?'Close currency selector':'Open currency selector');
      schedule();
      if(next)requestAnimationFrame(()=>widget?.querySelector('select,button')?.focus({preventScroll:true}));
    });
    document.body.appendChild(tab);
    return tab;
  }
  function closeMobile(){
    if(!document.documentElement.classList.contains(openClass))return;
    document.documentElement.classList.remove(openClass);
    const tab=document.querySelector('.ih-mobile-currency-tab');
    if(tab){tab.setAttribute('aria-expanded','false');tab.setAttribute('aria-label','Open currency selector');}
    schedule();
  }
  function closeDesktop(){
    if(!document.documentElement.classList.contains(desktopOpenClass))return;
    document.documentElement.classList.remove(desktopOpenClass);
    const tab=document.querySelector('.ih-desktop-currency-tab');
    if(tab){tab.setAttribute('aria-expanded','false');tab.setAttribute('aria-label','Open currency selector');}
    schedule();
  }
  function close(){closeMobile();closeDesktop();}
  function style(el,name,value){if(el.style.getPropertyValue(name)!==value||el.style.getPropertyPriority(name)!=='important')el.style.setProperty(name,value,'important');}
  function place(){
    widget=findWidget();
    if(!widget){if(++attempts>30)attempts=30;return;}
    attempts=0;
    widget.dataset.ihMlvWidget='true';
    style(widget,'position','fixed');
    style(widget,'right','auto');
    style(widget,'transform','none');
    style(widget,'margin','0px');
    style(widget,'z-index','10120');
    if(window.innerWidth<=MOBILE_MAX){
      closeDesktop();
      const desktopTabEl=document.querySelector('.ih-desktop-currency-tab');
      if(desktopTabEl)desktopTabEl.style.display='none';
      const tab=mobileTab();
      const open=document.documentElement.classList.contains(openClass);
      if(tab)tab.style.display='';
      style(widget,'top','auto');
      style(widget,'bottom','76px');
      style(widget,'z-index','122');
      style(widget,'left',open?'38px':'-200px');
      style(widget,'opacity',open?'1':'0');
      style(widget,'visibility',open?'visible':'hidden');
      style(widget,'pointer-events',open?'auto':'none');
      style(widget,'max-width','118px');
      style(widget,'transition','left .2s ease, opacity .15s ease');
      return;
    }
    closeMobile();
    const mobileTabEl=document.querySelector('.ih-mobile-currency-tab');
    if(mobileTabEl)mobileTabEl.style.display='none';
    // Preserve the merchant's "show currency" toggle; hide the old header slot.
    const slot=document.querySelector('.ih-b1-desktop-currency-slot');
    if(!slot){
      closeDesktop();
      const existingTab=document.querySelector('.ih-desktop-currency-tab');
      if(existingTab)existingTab.style.display='none';
      style(widget,'visibility','hidden');
      style(widget,'pointer-events','none');
      return;
    }
    const tab=desktopTab();
    const open=document.documentElement.classList.contains(desktopOpenClass);
    if(tab)tab.style.display='';
    const tabTop=tab?.getBoundingClientRect().top ?? Math.round(window.innerHeight*.40);
    const top=Math.max(65,Math.min(Math.round(tabTop),window.innerHeight-320));
    style(widget,'left',open?'42px':'-240px');
    style(widget,'top',top+'px');
    style(widget,'bottom','auto');
    style(widget,'z-index','1220');
    style(widget,'max-width','128px');
    style(widget,'visibility',open?'visible':'hidden');
    style(widget,'opacity',open?'1':'0');
    style(widget,'pointer-events',open?'auto':'none');
    style(widget,'transition','left .2s ease, opacity .15s ease');
  }
  function schedule(){cancelAnimationFrame(raf);raf=requestAnimationFrame(place);}
  function boot(){
    if(!document.body)return;
    observer?.disconnect();
    observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true});
    schedule();
  }
  document.addEventListener('click',event=>{
    const active=document.documentElement.classList.contains(openClass)||document.documentElement.classList.contains(desktopOpenClass);
    if(!active)return;
    if(event.target.closest('.ih-mobile-currency-tab,.ih-desktop-currency-tab')||(widget&&widget.contains(event.target)))return;
    close();
  },true);
  document.addEventListener('change',event=>{
    if(widget&&widget.contains(event.target))setTimeout(close,100);
  },true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')close();});
  document.addEventListener('click',event=>{
    if(!widget||!widget.contains(event.target))return;
    const before=signature();
    setTimeout(()=>{if(before&&signature()!==before)close();},450);
  },true);
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('scroll',schedule,{passive:true});
  document.addEventListener('shopify:section:load',boot);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
/* IH MLV DESKTOP DROPDOWN DOWNWARD — mobile selector is intentionally untouched */
(()=>{
  const minWidth=750;
  let checkFrame=0;
  let watchUntil=0;
  const selectors=[
    '[data-ih-mlv-widget="true"] .dropdown-menu',
    '[data-ih-mlv-widget="true"] .currency-list',
    '[data-ih-mlv-widget="true"] [class*="currency"][class*="dropdown"]',
    '[data-ih-mlv-widget="true"] [class*="mlveda"][class*="list"]',
    '[data-ih-mlv-widget="true"] .choices__list--dropdown',
    '.select2-container--open .select2-dropdown',
    '.pick_currency .dropdown-menu',
    '.pick_currency ul',
    '[class*="mlveda"][class*="dropdown"]',
    '[id*="mlveda"][id*="dropdown"]'
  ];
  function currencyMenu(el,widget){
    if(!el||el===widget||!el.isConnected||el.tagName==='SELECT'||el.tagName==='OPTION')return false;
    const style=getComputedStyle(el),r=el.getBoundingClientRect();
    if(style.display==='none'||style.visibility==='hidden'||r.width<44||r.height<24||r.height>750)return false;
    if(!['absolute','fixed'].includes(style.position)&&!el.classList.contains('select2-dropdown'))return false;
    if(widget.contains(el))return true;
    const codeList=(el.textContent||'').toUpperCase().match(/\b(INR|USD|EUR|GBP|AED|AUD|CAD|SGD|JPY|CNY|HKD|NZD|CHF)\b/g)||[];
    const likelyMLV=/mlveda|pick.currency|select2-dropdown/i.test(el.className+' '+el.id);
    const wr=widget.getBoundingClientRect();
    return (codeList.length>=2||likelyMLV)&&Math.abs(r.left-wr.left)<230;
  }
  function moveDown(){
    if(window.innerWidth<minWidth)return;
    const widget=document.querySelector('[data-ih-mlv-widget="true"]');
    if(!widget)return;
    const rect=widget.getBoundingClientRect();
    if(rect.width<10||rect.height<10)return;
    let candidates=[];
    for(const selector of selectors){
      try{candidates.push(...document.querySelectorAll(selector));}catch(e){}
    }
    const seen=new Set();
    for(const menu of candidates){
      if(seen.has(menu)||!currencyMenu(menu,widget))continue;
      seen.add(menu);
      const maxHeight=Math.max(100,Math.min(320,window.innerHeight-rect.bottom-12));
      const left=Math.max(8,Math.min(rect.left,window.innerWidth-menu.getBoundingClientRect().width-8));
      const attrs={
        position:'fixed',left:Math.round(left)+'px',right:'auto',
        top:Math.round(rect.bottom+5)+'px',bottom:'auto',
        transform:'none',zIndex:'10150',maxHeight:maxHeight+'px',
        overflowY:'auto'
      };
      for(const [key,value] of Object.entries(attrs)){
        if(menu.style.getPropertyValue(key)!==value||menu.style.getPropertyPriority(key)!=='important')
          menu.style.setProperty(key,value,'important');
      }
    }
  }
  function schedule(){
    if(window.innerWidth<minWidth)return;
    cancelAnimationFrame(checkFrame);
    checkFrame=requestAnimationFrame(moveDown);
  }
  document.addEventListener('pointerdown',event=>{
    if(window.innerWidth<minWidth)return;
    const widget=document.querySelector('[data-ih-mlv-widget="true"]');
    if(!widget||!widget.contains(event.target))return;
    watchUntil=Date.now()+1800;
    schedule();
    setTimeout(schedule,50);
    setTimeout(schedule,180);
    setTimeout(schedule,420);
  },true);
  document.addEventListener('focusin',event=>{
    if(window.innerWidth<minWidth)return;
    if(event.target.closest?.('[data-ih-mlv-widget="true"]')){
      watchUntil=Date.now()+1400;
      setTimeout(schedule,50);
    }
  },true);
  new MutationObserver(()=>{
    if(window.innerWidth>=minWidth && Date.now()<watchUntil)schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('scroll',schedule,{passive:true});
})();

/* IH FULL HEADER STICKY */
(()=>{
  function syncStickyHeader(){
    document.querySelectorAll('.ih-aza2-header').forEach(header=>{
      const inner=header.querySelector('.ih-aza2-sticky');
      const section=header.closest('.shopify-section');
      if(!section || !inner) return;

      const enabled=!inner.classList.contains('ih-aza2-sticky--off');
      section.classList.toggle('ih-aza2-section-sticky',enabled);

      // The Shopify section wrapper owns sticky positioning.
      // Keep the internal wrapper normal so the entire 3-row header moves as one unit.
      inner.classList.toggle('ih-aza2-sticky-managed',enabled);
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',syncStickyHeader,{once:true});
  }else{
    syncStickyHeader();
  }

  document.addEventListener('shopify:section:load',syncStickyHeader);
  document.addEventListener('shopify:section:reorder',syncStickyHeader);
})();


/* IH PRESTIGE PREDICTIVE SEARCH */
(()=>{
  const hosts=[...document.querySelectorAll('[data-ih-predictive]')];
  if(!hosts.length) return;

  const cache=new Map();
  const MIN_CHARS=2;
  const WAIT=180;

  function closeHost(host){
    const panel=host.querySelector('[data-ih-predictive-panel]');
    const input=host.querySelector('input[type="search"]');
    if(panel) panel.hidden=true;
    host.classList.remove('is-open','is-loading');
    input?.setAttribute('aria-expanded','false');
  }

  function buildUrl(endpoint,term){
    const url=new URL(endpoint,window.location.origin);
    url.searchParams.set('q',term);
    url.searchParams.set('resources[type]','query,product,collection,page,article');
    url.searchParams.set('resources[limit]','10');
    url.searchParams.set('resources[limit_scope]','each');
    url.searchParams.set('resources[options][unavailable_products]','show');
    url.searchParams.set(
      'resources[options][fields]',
      'title,body,product_type,tag,vendor,variants.title,variants.sku,variants.barcode,author'
    );
    url.searchParams.set('section_id','predictive-search');
    return url.toString();
  }

  async function renderResults(host,term,state){
    const panel=host.querySelector('[data-ih-predictive-panel]');
    const form=host.querySelector('form');
    const input=host.querySelector('input[type="search"]');
    const endpoint=host.dataset.predictiveUrl;

    if(!panel||!form||!input||!endpoint) return;

    const clean=term.trim();
    if(clean.length<MIN_CHARS){
      state.controller?.abort();
      closeHost(host);
      return;
    }

    const key=clean.toLowerCase();
    host.classList.add('is-loading');

    try{
      let html=cache.get(key);

      if(!html){
        state.controller?.abort();
        state.controller=new AbortController();

        const res=await fetch(buildUrl(endpoint,clean),{
          signal:state.controller.signal,
          headers:{Accept:'text/html'}
        });
        if(!res.ok) throw new Error('Predictive search request failed: '+res.status);
        html=await res.text();
        cache.set(key,html);
      }

      if(input.value.trim().toLowerCase()!==key) return;

      panel.innerHTML=html;

      // Prestige's predictive-search section ships a View All button that targets
      // its stock form ID. Point it to the custom header form instead.
      panel.querySelectorAll('[form="predictive-search-form"]').forEach(el=>{
        el.setAttribute('form',form.id);
      });

      panel.hidden=false;
      host.classList.add('is-open');
      input.setAttribute('aria-expanded','true');
    }catch(err){
      if(err?.name!=='AbortError'){
        panel.innerHTML='<p class="ih-predictive-error">Search suggestions are temporarily unavailable.</p>';
        panel.hidden=false;
        host.classList.add('is-open');
        input.setAttribute('aria-expanded','true');
      }
    }finally{
      host.classList.remove('is-loading');
    }
  }

  hosts.forEach(host=>{
    if(host.dataset.ihPredictiveBound==='true') return;
    host.dataset.ihPredictiveBound='true';

    const input=host.querySelector('input[type="search"]');
    const form=host.querySelector('form');
    if(!input||!form) return;

    const state={timer:0,controller:null};

    const queue=()=>{
      clearTimeout(state.timer);
      state.timer=setTimeout(()=>renderResults(host,input.value,state),WAIT);
    };

    input.addEventListener('input',queue);
    input.addEventListener('focus',()=>{
      if(input.value.trim().length>=MIN_CHARS) queue();
    });

    input.addEventListener('keydown',e=>{
      if(e.key==='Escape'){
        closeHost(host);
        input.blur();
      }
    });

    form.addEventListener('submit',()=>closeHost(host));
  });

  document.addEventListener('click',e=>{
    hosts.forEach(host=>{
      if(!host.contains(e.target)) closeHost(host);
    });
  });

  document.addEventListener('shopify:section:load',()=>{
    // Theme editor can reload header sections. A full page refresh is not needed;
    // newly rendered hosts will work on the next normal editor refresh.
  });
})();

/* Arjun search drawer toggle — reuses existing predictive-search form */
(()=>{
 const init=()=>{
  document.querySelectorAll('[data-ih-b1-search-toggle]').forEach(btn=>{
    if(btn.dataset.ihB1Bound)return;btn.dataset.ihB1Bound='1';
    const panel=document.getElementById(btn.getAttribute('aria-controls'));if(!panel)return;
    const close=()=>{panel.classList.remove('is-b1-open');btn.setAttribute('aria-expanded','false');};
    btn.addEventListener('click',e=>{e.preventDefault();const next=!panel.classList.contains('is-b1-open');if(next){panel.classList.add('is-b1-open');btn.setAttribute('aria-expanded','true');panel.querySelector('input[type=search]')?.focus()}else close()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
    document.addEventListener('pointerdown',e=>{if(!panel.contains(e.target)&&!btn.contains(e.target))close()});
  })
 };
 document.addEventListener('DOMContentLoaded',init,{once:true});if(document.readyState!=='loading')init();
 document.addEventListener('shopify:section:load',init);
})();
